import { useMutation } from "@apollo/client";
import { CreateContactDocument } from "@/__generated__/graphql";

export const useCreateContactMutation = () => {
  return useMutation(CreateContactDocument);
};
